import { useState, useEffect } from 'react';
import { META, ROUTES } from './data';
// Sterling & Hayes — court-document mono header. Brand serif, parchment bg, oxblood underline.
export default function Header({ page, setPage }) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', h, { passive: true });
    return () => window.removeEventListener('scroll', h);
  }, []);
  return (
    <header className={`sticky top-0 z-40 bg-[#E8DCC1] transition-all duration-700 ${scrolled ? 'border-b border-[#5C1F1A]/30 py-2' : 'py-5'}`}>
      <div className="max-w-[1500px] mx-auto px-8 lg:px-14 flex items-center justify-between gap-6">
        <button onClick={() => setPage('home')} data-testid="law-logo">
          <p className="font-serif text-2xl lg:text-3xl text-[#5C1F1A]" dangerouslySetInnerHTML={{ __html: META.brand }} />
          <p className="font-mono text-[8px] tracking-[0.4em] uppercase text-[#1F1B17]/55 leading-tight" dangerouslySetInnerHTML={{ __html: META.tag }} />
        </button>
        <nav className="hidden lg:flex items-center gap-9">
          {ROUTES.map(r => (
            <button key={r.id} onClick={() => setPage(r.id)} data-testid={`law-nav-${r.id}`}
              className={`relative font-serif text-base transition-colors ${page === r.id ? 'text-[#5C1F1A]' : 'text-[#1F1B17]/65 hover:text-[#1F1B17]'}`}>
              {r.label}
              {page === r.id && <span className="absolute -bottom-1 left-0 right-0 h-0.5 bg-[#B68F4E]" />}
            </button>
          ))}
        </nav>
        <button onClick={() => setPage('inquiry')} data-testid="law-cta-inquiry" className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#5C1F1A] border-b border-[#5C1F1A] pb-0.5 hover:text-[#1F1B17] hover:border-[#1F1B17]">Confidential inquiry →</button>
      </div>
    </header>
  );
}
